export default {
  small: 570,
  medium: 750,
  large: 990,
  huge: 1200
};
